import React from 'react'
import MonthlySpendingChart from '../atoms/MonthlySpendingChart'
import DailySpendingChart from '../atoms/DailySpendingChart'
import MonthlyTotalSpentChart from '../atoms/MonthlyTotalSpentChart'

const Analytics = () => {

    return (
        <div style={{ marginTop: '120px' }}>
            {/* Monthly and Daily Spending Charts */}
            <div style={{ 
                padding: '20px', 
                backgroundColor: '#f8f9fa', 
                display: 'flex', 
                gap: '20px', 
                alignItems: 'stretch',
                minHeight: '600px',
                flexWrap: 'wrap'
            }}>
                <div style={{ 
                    flex: '1 1 calc(50% - 10px)', 
                    minWidth: '600px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px'
                }}>
                    <MonthlySpendingChart />
                    <MonthlyTotalSpentChart />
                </div>
                <div style={{ 
                    flex: '1 1 calc(50% - 10px)', 
                    minWidth: '600px',
                    display: 'flex'
                }}>
                    <DailySpendingChart />
                </div>
            </div>
        </div>
    )
}

export default Analytics